import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TITLES = [
  ["/app/platform", "Platform Admin"], ["/app/settings", "Agency Settings"], ["/app/sessions", "Sessions"],
  ["/app/delivery", "Delivery Status"], ["/app/reports", "Time Reports"], ["/app/consent-link", "Consent Link"], ["/app", "Dashboard"],
  ["/login", "Sign in"], ["/forgot-password", "Reset password"], ["/reset-password", "Reset password"], ["/accept-invite", "Accept invite"],
  ["/consent", "Consent for Services"], ["/intake", "Intake"], ["/share", "Share Kit"],
];

export function usePageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const hit = TITLES.find(([p]) => pathname.startsWith(p) || pathname.endsWith(p));
    document.title = hit ? `${hit[1]} · Airfistuus` : "Airfistuus";
  }, [pathname]);
}
